import React, { useState } from "react";
import OutputTable from "../../OutputTable";
import CustomAccordion from "../../CustomAccordion";
import GenericForm from "../../GenericForm";
import CustomAlert from "../../Alert";
import { RENTAL_TEXTILE_LAUNDRY, CURRENCIES } from "../../../constants";
import { TextField, MenuItem } from "@mui/material";
import "../../../style.css";
import ApiClient from "../../../apisClient";

const api = new ApiClient();
const OverallAcordian = () => {
  const [cost, setCost] = useState(null);
  const [currency, setCurrency] = useState("USD");
  const [volume, setVolume] = useState(null);
  const [totalCost, setTotalCost] = useState(null);
  const [submittedData, setSubmittedData] = useState(null);
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [alertMessage, setAlertMessage] = useState("");

  const handleCostChange = (event) => setCost(event.target.value);
  const handleVolumeChange = (event) => setVolume(event.target.value);

  const handleCurrencyChange = (event) => {
    const selectedCurrency = event.target.value;
    setCurrency(selectedCurrency);

    const selectedCurrencyObject = CURRENCIES.find(
      (c) => c.value === selectedCurrency
    );
    setCurrencySymbol(
      selectedCurrencyObject ? selectedCurrencyObject.label : ""
    );
  };

  const handleSubmit_1 = async () => {
    if (cost < 0 || volume < 0) {
      setAlertMessage("Cost and volume must be greater than zero.");
      return;
    }
    //cost and volume is blank or empty
    if ((cost === null || cost === '' )|| volume === null || volume === '') {
      setAlertMessage("Please fill in all fields.");
      return;
    }
    const payload = {
      cost_per_wash: parseFloat(cost),
      volume_per_year: parseFloat(volume),
      currency: currency,
    };

    try {
      const data = await api.post("/api/v1/overall-cost", payload);
      const response = data;
      const numericCost = parseFloat(response.estimated_cost.replace(/[^\d.-]/g, ""));

      setSubmittedData(payload);
      setTotalCost(numericCost);
      setAlertMessage(""); // Clear any previous alert message
    } catch (error) {
      setAlertMessage("An error occurred while submitting the form.");
    }
  };

  const handleReset = () => {
    setCost('');
    setVolume('');
    setTotalCost('');
    setSubmittedData(null);
    setAlertMessage(""); // Clear any previous alert message
  };

  const formTableRows = [
    {
      title: RENTAL_TEXTILE_LAUNDRY.ACCORDIAN_TEXT,
      description: RENTAL_TEXTILE_LAUNDRY.ACCORDIAN_TEXT_BOLD,
      fields: [
        {
          label: "Cost of reimpregnation per wash per garment:",
          width: "360px",
          component: [
            <TextField
              size="small"
              placeholder="Enter cost"
              type="number"
              className="textFieldCustom"
              value={cost}
              inputProps={{ min: 0 }}
              onChange={handleCostChange}
            />,
            <TextField
              select
              label="Currency"
              name="currency"
              size="small"
              className="textFieldCustom"
              value={currency}
              align="left"
              onChange={handleCurrencyChange}
            >
              <MenuItem value="USD">USD</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
            </TextField>,
          ],
        },
        {
          label: "Yearly volume of garments being re-impregnated",
          name: "volume",
          component: [
            <TextField
              type="number"
              size="small"
              className="textFieldCustom"
              value={volume}
              onChange={handleVolumeChange}
              placeholder="Enter eaches"
            />,
            <TextField
              size="small"
              className="textFieldCustom"
              disabled
              variant="filled"
              placeholder="eaches / year"
            />,
          ],
        },
        {
          label: "Over 100 cleaning cycles",
          name: "over100CleaningCycles",
          width: "360px",
          component: [
            <TextField
              size="small"
              className="textFieldCustomLong"
              disabled
              variant="filled"
              placeholder="x100"
            />,
          ],
        },
      ],
      onSubmit: handleSubmit_1,
      onreset: handleReset,
    },
  ];

  const section_1 = [
    {
      title: RENTAL_TEXTILE_LAUNDRY.OVERALL_COST_TITLE,
      content: (
        <>
         
          <GenericForm
            title={formTableRows[0].title}
            description={formTableRows[0].description}
            fields={formTableRows[0].fields}
            onSubmit={formTableRows[0].onSubmit}
            onReset={formTableRows[0].onreset}
          />
           {alertMessage && <CustomAlert text={alertMessage} />}
          {submittedData && totalCost != null && !alertMessage && (
            <OutputTable
              title="Estimated cost of repellency treatment re-impregnation:"
              data={[
                {
                  label: "Cost of reimpregnation per wash per garment",
                  value: submittedData.cost_per_wash + " " + currencySymbol,
                },
                {
                  label: "Yearly volume of garments being re-impregnated",
                  value: submittedData.volume_per_year,
                },
                { label: "Over 100 cleaning cycles", value: "x100" },
                { label: "Estimated Cost", value: totalCost + " " + currencySymbol },
              ]}
            />
          )}
        </>
      ),
    },
  ];

  return <CustomAccordion sections={section_1} isExpanded={true} />;
};

export default OverallAcordian;